import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500 my-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, "$")
], -1)
const _hoisted_4 = ["value", "id", "name", "placeholder", "disabled"]
const _hoisted_5 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['absolute inset-y-0 right-0 pr-3 flex items-center'])
}
const _hoisted_6 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}

import { computed, ref, watch, withDefaults } from "vue"
import { ExclamationCircleIcon } from "@heroicons/vue/solid"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { cleaveDirective as vCleave } from "@/shared/directives/cleave-directive"
import Cleave from "cleave.js"

interface Props {
    modelValue?: string | number
    label?: string
    description?: string
    name?: string
    required?: boolean
    placeholder?: string
    inline?: boolean
    invalid?: boolean
    small?: boolean
    errorMessage?: string
    disabled?: boolean
    textAlign?: string
    inputClass?: string
    wrapperClass?: string
    readonly?: boolean
    showRequired?: boolean
    fullWidth?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsPriceInput',
  props: {
    modelValue: {},
    label: {},
    description: {},
    name: {},
    required: { type: Boolean, default: false },
    placeholder: {},
    inline: { type: Boolean },
    invalid: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    errorMessage: {},
    disabled: { type: Boolean, default: false },
    textAlign: { default: "start" },
    inputClass: { default: "" },
    wrapperClass: {},
    readonly: { type: Boolean },
    showRequired: { type: Boolean, default: true },
    fullWidth: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const showErrors = ref(true)
const localErrorMessage = ref(props.errorMessage)
const localInvalid = ref(props.invalid)

const baseStyle = computed(() => [
    "pl-7 pr-12",
    props.inline ? "w-80" : "",
    props.small ? "text-sm" : "text-base",
    props.fullWidth ? "w-full" : "",
    "appearance-none block px-3 py-2 border rounded-md shadow-sm",
    props.inputClass,
    `text-${props.textAlign}`,
])

const inputStyle = computed(() => [
    ...baseStyle.value,
    props.disabled ? "opacity-50 cursor-not-allowed" : "",
    localInvalid.value && showErrors.value
        ? "pr-10 border-red-300 placeholder-red-300 focus:ring-red-500 focus:border-red-500"
        : "placeholder-gray-400 focus:ring-primary-color-500 focus:border-primary-color-500 border-gray-300 ",
    "focus:outline-none",
])

const readonlyStyle = computed(() => [
    ...baseStyle.value,
    "opacity-50 cursor-not-allowed",
    "bg-gray-100",
    "border-gray-300 placeholder-gray-400",
])

const starStyle = computed(() => [localInvalid.value ? "text-red-600" : "text-gray-700", "pl-1"])
const getRequiredStyleInline = computed(() => (props.inline ? "gap-2" : ""))
const inputField = ref<(HTMLInputElement & { cleave: Cleave }) | null>(null)

function getInlineLabelStyle() {
    return [props.inline ? "w-2/5" : "", "h-6"]
}

function getWrapperStyleInline() {
    return [props.inline ? "flex items-center gap-4" : "", props.wrapperClass]
}

function getInputWrapperStyleLabel() {
    return ["relative flex items-center justify-center"]
}

function disableValidationError() {
    localErrorMessage.value = ""
    localInvalid.value = false
}

function onChangeInput() {
    disableValidationError()
    if (inputField.value) {
        emit("update:modelValue", inputField.value.cleave.getRawValue())
    }
}

watch(
    () => props.errorMessage,
    (newVal) => {
        localErrorMessage.value = newVal
        localInvalid.value = props.invalid
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass([getWrapperStyleInline()])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex", getRequiredStyleInline.value])
      }, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              for: _ctx.name,
              class: _normalizeClass(["text-sm font-medium text-gray-700", getInlineLabelStyle()])
            }, _toDisplayString(_ctx.label), 11, _hoisted_1))
          : _createCommentVNode("", true),
        (_ctx.required && _ctx.showRequired)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(starStyle.value)
            }, "*", 2))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(getInputWrapperStyleLabel())
      }, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          ref_key: "inputField",
          ref: inputField,
          value: _ctx.modelValue,
          id: _ctx.name,
          name: _ctx.name,
          type: "text",
          placeholder: _ctx.placeholder,
          disabled: _ctx.disabled || _ctx.readonly,
          class: _normalizeClass(_ctx.readonly ? readonlyStyle.value : inputStyle.value),
          onInput: onChangeInput,
          onBlur: _cache[0] || (_cache[0] = ($event: any) => (showErrors.value = true))
        }, null, 42, _hoisted_4), [
          [_unref(vCleave), { numeral: true, numeralThousandsGroupStyle: 'thousand' }]
        ]),
        (localInvalid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (localInvalid.value && showErrors.value)
                ? (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
                    key: 0,
                    class: "h-5 w-5 text-red-600",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (localErrorMessage.value && showErrors.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(localErrorMessage.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})